// Where each resident's body is actually DRAWN this frame (CityResident), which
// can trail their timeline position a little — and at a car's speed, by a car
// length or more. A camera that follows someone (a replay's ride between
// scenes) aims at this, not at where the timeline says they should be.
export const bodyAt = new Map();   // avatarId → { x, y, z, heading, at (performance.now) }

// Whose REAL body is drawn now (not the grey stand-in): CityResident adds an
// avatar when its body reports ready, and takes it out when the body goes. A
// still of a moment (city/moment) waits for both of its people to be in here.
export const readyBodies = new Set();   // avatarId
// …and since when (performance.now): a body is "ready" the moment its mesh is in
// the scene, before its idle clip has faded in (0.25 s) — the first real still
// caught one mid-fade, arms out in its bind pose. A still waits a beat past this.
export const readyAt = new Map();       // avatarId → performance.now()
